module.exports = __webpack_public_path__ + "img/bow.compound.bc6f2a9a.png";